<hw-page-header header="term.di-06.header" class="page-header"></hw-page-header>
<nz-content class="main">
  <div *ngIf="version1 && version2 && diff">
    <div nz-row>
      <div nz-col [nzXs]="{ span: 2, offset: 1 }" [nzLg]="{ span: 3, offset: 2 }">code</div>
      <div nz-col [nzXs]="{ span: 11, offset: 1 }" [nzLg]="{ span: 6, offset: 2 }">version {{ version1.version }}</div>
      <div nz-col [nzXs]="{ span: 5, offset: 1 }" [nzLg]="{ span: 6, offset: 2 }">version {{ version2.version }}</div>
    </div>
    <div nz-row *ngFor="let d of diff">
      <nz-divider nzType="horizontal"></nz-divider>
      <div nz-col [nzXs]="{ span: 2, offset: 1 }" [nzLg]="{ span: 3, offset: 2 }">
        {{ d.code }}
      </div>
      <div nz-col [nzXs]="{ span: 11, offset: 1 }" [nzLg]="{ span: 6, offset: 2 }">
        <concept-attributes-card
          *ngIf="d.entity1"
          [bodyClass]="d.entity2 ? '' : 'bg-danger'"
          [attributes]="d.entity1.attributes">
          <p *ngIf="d.entity1.parent">&nbsp;└── {{ d.entity1.parent }}</p>
        </concept-attributes-card>
      </div>
      <div nz-col [nzXs]="{ span: 5, offset: 1 }" [nzLg]="{ span: 6, offset: 2 }">
        <concept-attributes-card
          *ngIf="d.entity2"
          [bodyClass]="d.entity1 ? '' : 'bg-success'"
          [attributes]="d.entity2.attributes">
          <p *ngIf="d.entity2.parent">&nbsp;└── {{ d.entity2.parent }}</p>
        </concept-attributes-card>
      </div>
    </div>
  </div>
</nz-content>
